import { combineReducers } from 'redux';

import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { FETCH_QUESTION_MODELS } from 'modules/questionModels/actionTypes';

export default combineReducers({
  select: createSearchReducers(FETCH_QUESTION_MODELS, {
    global: { matcher: ({ meta }) => meta?.source === 'questionSelfServiceStats' },
  }),
});
